import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    // observaciones: '',
    inactivo: false,
    rowVersion: null,

    impuestoOrganismoDatos: [],
    impuestoOrganismoNombre: '',    
    // impuestoOrganismoImpuestosDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, impuestoOrganismoId) {
        state.id = impuestoOrganismoId;
        state.nombre = '';
        // state.observaciones = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_IMPUESTO_ORGANISMO'(state, impuestoOrganismo) {
        state.nombre = impuestoOrganismo.nombre.toUpperCase().trim();
        // state.observaciones = impuestoOrganismo.observaciones.toUpperCase().trim();
        state.inactivo = impuestoOrganismo.inactivo;
        state.rowVersion = impuestoOrganismo.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.impuestoOrganismoDatos = [];
        // state.impuestoOrganismoImpuestosDatos = [];
        state.impuestoOrganismoNombre = '';
    },
    'SET_DATOS'(state, params) {
        state.impuestoOrganismoDatos = params.impuestoOrganismoDatos;
        // state.impuestoOrganismoImpuestosDatos = params.impuestoOrganismoImpuestosDatos;
        state.impuestoOrganismoNombre = params.impuestoOrganismoNombre;
    },
};

const getters = {
    getField,

    nombre(state) {
        return state.impuestoOrganismoNombre;
    }
};

const actions = {
    inicializar ( { commit }, impuestoOrganismoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', impuestoOrganismoId);
            
            if (impuestoOrganismoId != 0) {
                apiAxios.get('impuestosorganismos/' + impuestoOrganismoId + '/abm' ) 
                .then(res => {
                    commit('SET_IMPUESTO_ORGANISMO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let impuestoOrganismo= {
                nombre: state.nombre.toUpperCase().trim(),
                // observaciones: state.observaciones.trim(),
                inactivo: state.inactivo,
            }

            let url = 'impuestosorganismos';
            if (state.id != 0) {
                url += "/" + state.id;
                impuestoOrganismo.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, impuestoOrganismo)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, impuestoOrganismoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            let getDatos = false;

            if (impuestoOrganismoId) {
                if (impuestoOrganismoId != 0) {
                    getDatos = true;
                }
            }

            if (getDatos) {
                apiAxios.get('impuestosorganismos/' + impuestoOrganismoId ) 
                .then(res => {

                    let impuestoOrganismoDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        // { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        impuestoOrganismoDatos,
                        // impuestoOrganismoImpuestosDatos: res.data.impuestos
                        impuestoOrganismoNombre: res.data.nombre
                    };

                    commit('SET_DATOS', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}